import React from 'react'
import { connect } from 'react-redux'
import { doGetEmail, doSendEmail } from '../../reducers/actions'

class EmailDiv extends React.Component {
  state = {}
  componentDidMount = () => {
    const { onClose, dispatch, id } = this.props
    dispatch(doGetEmail({
      id,
      onEnd: ({ errorMessage, initValues基本信息 }) => {
        if (errorMessage) {
          Tyan.pubForm.showError(errorMessage)
        }
        else if (initValues基本信息) {
          this.setState({ id, initValues基本信息, changedValues基本信息: {} })
        }
      }
    }))
  }

  handlerConfirm = () => {
    const { initValues基本信息, id } = this.state
    const { onSave, onClose, dispatch } = this.props
    dispatch(doSendEmail({
      id,
      onEnd: ({ errorMessage }) => {
        if (errorMessage) {
          Tyan.pubForm.showError(errorMessage)
        }
        else {
          Ext.toast('发送成功')
          onSave && onSave()
          onClose && onClose()
        }
      }
    }))
  }

  handlerClose = () => {
    const { onClose } = this.props
    onClose && onClose()
  }

  fieldset基本信息 = () => {
    const { initValues基本信息, changedValues基本信息 } = this.state
    const values = { ...initValues基本信息, ...changedValues基本信息 }
    return [
      { _text: '收件人', name: '收件人', minWidth: '1000px', disabled: true },
      { _text: '抄送', name: '抄送', minWidth: '1000px', disabled: true },
      { _text: '密抄', name: '密抄', minWidth: '1000px', disabled: true },
      { _text: '主体', name: '主体', minWidth: '1000px', disabled: true },
      { _html: '<font style=\'font-weight:bold;font-size:14px;\'>正文</font>', name: '正文', minWidth: '1000px', },
    ]
  }

  render() {
    const { showMessage: Message, showBody: Body, id } = this.props
    const { initValues基本信息 } = this.state
    if (!initValues基本信息) return <Message text={'请稍等 ...'} />
    return <Body data={this} maxWidth="1200"
      controls={
        [
          { _button: '重新发送', icon: 'envelope-o', handler: this.handlerConfirm },
          { _button: '关闭', icon: 'close', handler: this.handlerClose },
        ]}
      fieldsets={
        [
          { title: '', name: '基本信息', _fieldset: this.fieldset基本信息() },
        ]}
    />
  }
}

export default connect()(EmailDiv)